import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large"
  }, [_c("h1", [_vm._v("Purchase Orders")]), _c("div", {
    staticClass: "search-global-container"
  }, [_c("div", {
    staticClass: "search-top-buttons"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.importSupplierPrices();
      }
    }
  }, [_c(VIcon, {
    staticClass: "--margin-right",
    attrs: {
      small: "",
      dark: ""
    }
  }, [_vm._v("fas fa-file-upload")]), _vm._v(" Import supplier prices ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.goToNewPurchaseOrder();
      }
    }
  }, [_c(VIcon, {
    attrs: {
      small: "",
      dark: ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" new purchase order ")], 1)], 1), _c("div", {
    staticClass: "search-main-line"
  }, [_c("div", {
    staticClass: "search-main-text-field"
  }, [_c(VTextField, {
    attrs: {
      solo: "",
      "hide-details": "auto",
      placeholder: "Search for a reference, supplier ...",
      "append-icon": "fa-search",
      clearable: ""
    },
    on: {
      "click:append": function clickAppend($event) {
        return _vm.search(true);
      },
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.search(true);
      },
      "click:clear": function clickClear() {
        _vm.searchCriterias.label = null;
        _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.label,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "label", $$v);
      },
      expression: "searchCriterias.label"
    }
  })], 1), _c("div", {
    staticClass: "search-pagination-limit"
  }, [_c(VSelect, {
    staticClass: "paging-limits-select",
    attrs: {
      solo: "",
      "hide-details": "auto",
      items: _vm.pagingLimitsChoices
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias.paging, "limits", $$v);
      },
      expression: "searchCriterias.paging.limits"
    }
  })], 1)]), _c("div", {
    staticClass: "search-table-top"
  }, [_c("div", {
    staticClass: "search-other-fields"
  }, [_c("div", [_c(VAutocomplete, {
    attrs: {
      items: _vm.references,
      "item-value": "id",
      "item-text": "reference",
      label: "References",
      "hide-details": "auto",
      clearable: "",
      solo: "",
      multiple: "",
      chips: "",
      "deletable-chips": ""
    },
    on: {
      blur: function blur($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.referenceIds,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "referenceIds", $$v);
      },
      expression: "searchCriterias.referenceIds"
    }
  }), _c(VAutocomplete, {
    attrs: {
      items: _vm.suppliers,
      disabled: _vm.isFetchingSuppliers,
      "item-value": "id",
      "item-text": "name",
      label: _vm.isFetchingSuppliers ? "Loading suppliers ..." : "Suppliers",
      "hide-details": "auto",
      clearable: "",
      solo: "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      filter: _vm.filterVAutocomplete
    },
    on: {
      blur: function blur($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.supplierIds,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "supplierIds", $$v);
      },
      expression: "searchCriterias.supplierIds"
    }
  })], 1), _c("div", [_c(VAutocomplete, {
    attrs: {
      items: _vm.listWines,
      disabled: _vm.isLoadingWines,
      color: "white",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      solo: "",
      "item-text": "display_name",
      "item-value": "id_wine",
      label: _vm.isLoadingWines ? "Loading products ..." : "Product",
      placeholder: "Type a product name, domain name, vintage...",
      filter: _vm.filterVAutocomplete,
      clearable: ""
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.wineId,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "wineId", $$v);
      },
      expression: "searchCriterias.wineId"
    }
  }), _c(VSelect, {
    attrs: {
      items: _vm.purchaseOrderReceiptStatus,
      "item-value": "value",
      "item-text": "label",
      label: "Receipt Status",
      "hide-details": "auto",
      solo: "",
      clearable: ""
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.receipt,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "receipt", $$v);
      },
      expression: "searchCriterias.receipt"
    }
  })], 1)]), _c("div", {
    staticClass: "search-other-fields"
  }, [_c("div", [_c(VSelect, {
    attrs: {
      solo: "",
      items: _vm.purchaseOrderStatus,
      "item-value": "value",
      "item-text": "label",
      label: "State",
      clearable: "",
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      },
      "click:clear": function clickClear() {
        _vm.searchCriterias.type = null;
        _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.type,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "type", $$v);
      },
      expression: "searchCriterias.type"
    }
  }), _c(VSelect, {
    attrs: {
      items: _vm.purchaseOrderPaymentStatus,
      "item-value": "value",
      "item-text": "label",
      label: "Payment Status",
      "hide-details": "auto",
      solo: "",
      clearable: ""
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.payment,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "payment", $$v);
      },
      expression: "searchCriterias.payment"
    }
  })], 1)]), _c("div", {
    staticClass: "search-pagination-index"
  }, [_c("Index", {
    attrs: {
      currentPage: +_vm.searchCriterias.paging.currentPage,
      limits: +_vm.searchCriterias.paging.limits,
      totalNumber: _vm.purchaseOrderCount
    }
  })], 1)])]), _c("div", {
    staticClass: "list-container"
  }, [_c(VDataTable, {
    staticClass: "elevation-2 cursor--pointer",
    attrs: {
      headers: _vm.headers,
      items: _vm.items,
      "items-per-page": +_vm.searchCriterias.paging.limits,
      loading: _vm.isLoading,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "disable-sort": ""
    },
    on: {
      "click:row": _vm.getToEditPurchaseOrder,
      "contextmenu:row": _vm.rowClickContextMenu
    },
    scopedSlots: _vm._u([{
      key: "item.isAllocation",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [item.isAllocation ? _c(VIcon, {
          attrs: {
            color: "#777777",
            left: "",
            small: ""
          }
        }, [_vm._v("fas fa-check")]) : _c("span", [_vm._v("-")])];
      }
    }, {
      key: "item.status",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [item.status === _vm.purchaseOrder.status.OPEN ? _c("div", {
          staticClass: "badge info"
        }, [_vm._v("Open")]) : item.status === _vm.purchaseOrder.status.CLOSED ? _c("div", {
          staticClass: "badge success"
        }, [_vm._v(" Closed ")]) : item.status === _vm.purchaseOrder.status.CANCELLED ? _c("div", {
          staticClass: "badge danger"
        }, [_vm._v(" Cancelled ")]) : _c("div", {
          staticClass: "badge warning"
        }, [_vm._v("Draft")])];
      }
    }, {
      key: "item.creationDate",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(_vm._f("formatDate")(item.creationDate)) + " ")];
      }
    }, {
      key: "item.expectedDeliveryDate",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s(_vm._f("formatDate")(item.expectedDeliveryDate)) + " ")];
      }
    }, {
      key: "item.receiptStatus",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_c("div", [_c("svg", {
          staticClass: "icon icon-xxs dot",
          class: [item.receiptStatus === _vm.purchaseOrder.receiptStatus.RECEIVED ? "fill-success" : "fill-empty"],
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            width: "512",
            height: "512",
            viewBox: "0 0 512 512"
          }
        }, [_c("circle", {
          attrs: {
            cx: "256",
            cy: "256",
            r: "256"
          }
        })]), _vm._v(" " + _vm._s(_vm.purchaseOrder.receiptStatus[item.receiptStatus] && _vm.purchaseOrder.receiptStatus[item.receiptStatus].text) + " ")]), item.receiptStatus !== _vm.purchaseOrder.receiptStatus.RECEIVED && item.status !== _vm.purchaseOrder.status.DRAFT && item.status !== _vm.purchaseOrder.status.CANCELLED && new Date(item.expectedDeliveryDate) < new Date() && Date.diffDays(new Date(item.expectedDeliveryDate), new Date()) > 0 ? _c("div", {
          staticClass: "overdue-text"
        }, [_vm._v(" Receipt late by " + _vm._s(Date.diffDays(new Date(item.expectedDeliveryDate), new Date())) + " days ")]) : item.receiptStatus === _vm.purchaseOrder.receiptStatus.RECEIVED && !!item.actualDeliveryDate ? _c("div", {
          staticClass: "text-smaller"
        }, [_vm._v(" " + _vm._s(_vm._f("formatDate")(item.actualDeliveryDate)) + " ")]) : _vm._e()];
      }
    }, {
      key: "item.paymentStatus",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_c("div", [_c("svg", {
          staticClass: "icon icon-xxs dot",
          class: [item.paymentStatus === _vm.purchaseOrder.paymentStatus.PAID ? "fill-success" : "fill-empty"],
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            width: "512",
            height: "512",
            viewBox: "0 0 512 512"
          }
        }, [_c("circle", {
          attrs: {
            cx: "256",
            cy: "256",
            r: "256"
          }
        })]), _vm._v(" " + _vm._s(_vm.purchaseOrder.paymentStatus[item.paymentStatus] && _vm.purchaseOrder.paymentStatus[item.paymentStatus].text) + " ")]), item.receiptStatus === _vm.purchaseOrder.receiptStatus.RECEIVED && item.paymentStatus !== _vm.purchaseOrder.paymentStatus.PAID && item.status !== _vm.purchaseOrder.status.DRAFT && item.status !== _vm.purchaseOrder.status.CANCELLED && item.billDate !== null && new Date(item.billDate).addDays((item.terms - 1) * 30) < new Date() && Date.diffDays(new Date(item.billDate).addDays((item.terms - 1) * 30), new Date()) > 0 ? _c("div", {
          staticClass: "overdue-text"
        }, [_vm._v(" Overdue by " + _vm._s(Date.diffDays(new Date(item.billDate).addDays((item.terms - 1) * 30), new Date())) + " days ")]) : item.paymentStatus === _vm.purchaseOrder.paymentStatus.PAID && !!item.paymentDate ? _c("div", {
          staticClass: "text-smaller"
        }, [_vm._v(" " + _vm._s(_vm._f("formatDate")(item.paymentDate)) + " ")]) : _vm._e()];
      }
    }, {
      key: "item.amount",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return [_vm._v(_vm._s(_vm.formatPrice(item.amount)) + " €")];
      }
    }, {
      key: "item.files",
      fn: function fn(_ref8) {
        var item = _ref8.item;
        return [_c("div", {
          staticClass: "td-without-link",
          on: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_c("div", {
          staticClass: "mt-1"
        }, [_c(VBtn, {
          staticClass: "dfwa-btn --small-2",
          attrs: {
            rounded: "",
            loading: _vm.isDownloadingPoFile
          },
          on: {
            click: function click($event) {
              return _vm.downloadPoFile(item.id);
            }
          }
        }, [_c(VIcon, {
          staticClass: "fa fa-download mr-1",
          attrs: {
            size: "0.65rem"
          }
        }), _vm._v(" PO PDF ")], 1)], 1), _c("div", {
          staticClass: "mb-1"
        }, [_c(VBtn, {
          staticClass: "dfwa-btn --small-2 secondary",
          attrs: {
            rounded: ""
          },
          on: {
            click: function click($event) {
              return _vm.openAttachedFilesDrawer(item.id);
            }
          }
        }, [_c(VIcon, {
          staticClass: "fas fa-file-import mr-1",
          attrs: {
            size: "0.65rem"
          }
        }), _vm._v(" Attached files ")], 1)], 1)])];
      }
    }], null, true)
  })], 1), _vm.hasResult ? _c("div", {
    staticClass: "table-bottom-container"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-paging"
  }, [_c("Paging", {
    attrs: {
      numberOfPages: _vm.numberOfPages,
      currentPage: +_vm.searchCriterias.paging.currentPage
    },
    on: {
      changePage: _vm.changePage
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-right"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-limit"
  }, [_c(VSelect, {
    attrs: {
      items: _vm.pagingLimitsChoices,
      solo: "",
      "hide-details": "auto"
    },
    on: {
      change: _vm.search
    },
    model: {
      value: _vm.searchCriterias.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias.paging, "limits", $$v);
      },
      expression: "searchCriterias.paging.limits"
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-pagination-index"
  }, [_c("Index", {
    attrs: {
      currentPage: +_vm.searchCriterias.paging.currentPage,
      limits: +_vm.searchCriterias.paging.limits,
      totalNumber: _vm.purchaseOrderCount
    }
  })], 1)])]) : _vm._e(), _vm.attachedFilesPoId > 0 ? _c("PurchaseOrderAttachedFilesDrawer", {
    ref: "PurchaseOrderAttachedFilesDrawer",
    attrs: {
      id: _vm.attachedFilesPoId
    }
  }) : _vm._e(), _vm.isImportSupplierPricesShown ? _c("ImportSupplierPrices", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    },
    model: {
      value: _vm.isImportSupplierPricesShown,
      callback: function callback($$v) {
        _vm.isImportSupplierPricesShown = $$v;
      },
      expression: "isImportSupplierPricesShown"
    }
  }) : _vm._e(), _c("ContextMenu", {
    ref: "contextMenu"
  }), _c("Confirm", {
    ref: "confirm"
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };